import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import { connect } from 'react-redux'
import { Tooltip } from 'react-wot-bootstrap'

import { ReserveTooltipBody } from './components/ReserveTooltipBody'
import { MAX_BUILDING_LEVEL } from 'constants'

import { toCssClass } from 'helpers'
import {
    RESERVE_TITLES,
    LEVEL_STRING,
} from 'helpers/i18n.jsx'
import {
    getGroupByReserve,
    getTargetType,
} from 'helpers/reserves'

import styles from './ReserveTooltip.scss'

export class ReserveTooltip extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        level: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        settings: PropTypes.object.isRequired,
        footer: PropTypes.node,
        isClientParametersVisible: PropTypes.bool,
        className: PropTypes.string,
        classNames: PropTypes.shape({
            info: PropTypes.string,
        }),
    }

    render() {
        const {
            className,
            classNames = {},
            id,
            type,
            level,
            settings,
            isClientParametersVisible,
            footer,
        } = this.props

        const imageClassName = cx(
            styles.image,
            styles[`image__${toCssClass(type)}`], {
                [styles.image__elite] : level > MAX_BUILDING_LEVEL,
            }
        )
        const reserveInfo = settings.reserves[type]

        const currentBonus = reserveInfo.bonus.values[level - 1]
        const reserveGroup = getGroupByReserve(type, settings)
        const bonusValuesArray = Object.values(currentBonus.battle_types)
        const targetType = getTargetType(reserveGroup, bonusValuesArray)

        return (
            <Tooltip id={id} isWide>
                <div className={cx(styles.base, styles[`base__type-${targetType}`], className)}>
                    <div className={styles.header}>
                        <div className={styles.button}>
                            <div className={styles.thumbnail}>
                                <div className={imageClassName} />
                            </div>
                        </div>
                        <div className={cx(styles.info, classNames.info)}>
                            <p className={styles.title}>{RESERVE_TITLES[reserveInfo.type]}</p>
                            <p className={styles.level}>{LEVEL_STRING(level)}</p>
                        </div>
                    </div>
                    <div className={styles.content}>
                        <ReserveTooltipBody
                            reserveType={type}
                            reserveInfo={reserveInfo}
                            level={level}
                            isClientParametersVisible={isClientParametersVisible}
                        />
                    </div>
                    {footer && (
                        <div className={styles.content}>{footer}</div>
                    )}
                </div>
            </Tooltip>
        )
    }
}

export const mapStateToProps = (state, { id, type, level }) => {
    const { settings } = state
    return {
        id,
        level,
        type,
        settings,
    }
}

export default connect(mapStateToProps)(ReserveTooltip)



// WEBPACK FOOTER //
// ./components/ReserveTooltip/ReserveTooltip.jsx